import Vue from "vue";
import Router from "vue-router";

import LinkShowAll from "@/components/LinkShowAll";
import LinkAddNew from "@/components/LinkAddNew";
import LinkViewInfo from "@/components/LinkViewInfo";
import LinkEditInfo from "@/components/LinkEditInfo";

import Login from "@/components/Login";
import Register from "@/components/Register";
import firebase from "firebase";

Vue.use(Router);

let router = new Router({
  // mode:'history',   //aded to remove # from url

  routes: [
    /*
    {
      path: "/",
      name: "dashboard",
      component: Dashboard
    },
    */
    {
      path: "/",
      name: "linkshowall",
      component: LinkShowAll
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: "/new",
      name: "addnew-linkinfo",
      component: LinkAddNew,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/:link_id",
      name: "edit-linkinfo",
      component: LinkEditInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/view/:link_id",
      name: "view-linkinfo",
      component: LinkViewInfo,
      meta: {
        requirgesAuth: true
      }
    },
    /*
    {
      path: "/:linko_id",
      name: "microweb",
      component: Dashboard
    }
    */
    {
      path: "/:linko_id",
      name: "showall-links",
      component: LinkShowAll
    }
  ]
});

// Nav Guards

router.beforeEach((to, from, next) => {
  // check for required auth guard

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // check if NOT logged in
    if (!firebase.auth().currentUser) {
      // Go to login
      next({
        path: "/login",
        query: {
          redirect: to.fullpath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (firebase.auth().currentUser) {
      // Go to login
      next({
        path: "/",
        query: {
          redirect: to.fullpath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js